import type { IOption } from 'common/interfaces/IOption'

export const PATIENT_ACTIVITY_INTERVAL: IOption[] = [
  { code: 15, name: '15 min' },
  { code: 20, name: '20 min' },
  { code: 25, name: '25 min' },
  { code: 30, name: '30 min' },
]

export const PATIENT_CONFIRM_APPT_BEFORE: IOption[] = [
  { code: '0', name: '0 days' },
  { code: '1', name: '1 day' },
  { code: '2', name: '2 days' },
  { code: '3', name: '3 days' },
  { code: '4', name: '4 days' },
]
